<template>
  <Modal
    v-model:is-open="isOpen"
    class="track-order-modal"
    :test-id="TEST_IDS.TRACK_ORDER_MODAL"
  >
    <div class="flex items-center justify-between">
      <h1 class="flex items-center gap-1 font-bold">
        <span class="text-size_6"> {{ $t("user.orders.labels.track") }}</span>
        <span class="text-size_5 text-action">#{{ orderId }}</span>
      </h1>

      <IconButton :c_style="{ type: 'ghost' }" @click="handleClose">
        <CommonUIcons name="ic-x" class="h-icon_size_5 w-icon_size_5" />
      </IconButton>
    </div>

    <CommonSeparator variant="horizontal" weight="thin" class="mb-5" />

    <div v-if="statuses" class="flex flex-col gap-7">
      <div
        v-for="(status, index) in statuses"
        class="flex items-start text-size_4"
        :key="status.name"
      >
        <div class="flex flex-col">
          <div class="flex items-start gap-8">
            <div class="relative pt-1">
              <div
                :class="[
                  'absolute left-0 z-10 flex h-3 w-3 items-center justify-center rounded-full',
                  status.changed_at
                    ? 'bg-action'
                    : 'border border-neutral-600 bg-neutral-50',
                ]"
              />
              <div
                v-if="!(statuses.length === index + 1)"
                class="absolute left-1.5 h-[72px] w-px border-l border-dashed"
                :class="
                  status.changed_at ? 'border-action' : 'border-neutral-900/40'
                "
              />
            </div>

            <span
              :test-id="
                status.changed_at
                  ? TEST_IDS.ORDER_ACTIVE_STATUS
                  : TEST_IDS.ORDER_STATUS
              "
              :class="
                status.changed_at
                  ? 'font-bold text-action'
                  : 'font-medium text-neutral-900/40'
              "
            >
              {{ status.name }}
            </span>
          </div>
          <span
            class="h-5 pl-8 text-size_3 font-medium text-neutral-900/40"
            :class="{ invisible: !status.changed_at }"
          >
            {{ status.changed_at?.split(" ")[0] }}
          </span>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import IconButton from "~/components/common/Atom/IconButton.vue";
import Modal from "~/components/common/Atom/Modal.vue";
import CommonSeparator from "~/components/common/Atom/Separator.vue";
import TEST_IDS from "~~/tests/constants/ids";

const isOpen = defineModel("isOpen", { default: false });

const emit = defineEmits(["close"]);

defineProps<{
  orderId: string;
  statuses?: {
    changed_at: string | null;
    name: string;
    order: number;
    is_cancel: number;
  }[];
}>();

const handleClose = () => {
  isOpen.value = false;
  emit("close");
};
</script>

<style>
.track-order-modal {
  .modal-content {
    @apply flex flex-col gap-5 pb-14 pt-8;
  }
}
</style>
